import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import { memo } from 'react';
import { DraggableProvided } from 'react-beautiful-dnd';

import { Icon } from '@/components/core/Icon';
import { Tooltip } from '@/components/core/Tooltip';
import { useAttributeLabelTranslator } from '@/components/datamodel/hooks/useAttributeLabelTranslator';
import { DataModelAttribute } from '@/types/DataModel';

interface DraggableAttributeProps {
    attribute: DataModelAttribute;
    provided: DraggableProvided;
    isSelected?: boolean;
}

const CoreDraggableAttribute = ({ attribute, isSelected, provided }: DraggableAttributeProps) => {

    const { translateAttributeLabel } = useAttributeLabelTranslator();
    const attributeLabel = translateAttributeLabel(attribute);

    return (
        <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={`
                        tw-relative
                        tw-w-full
                        tw-flex
                        tw-flex-row
                        tw-items-center
                        tw-justify-start
                        tw-bg-red
                        tw-border
                        tw-border-solid
                        tw-border-gray-300
                        tw-p-1
                        tw-mb-2
                        hover:tw-bg-primary-lighter
                        tw-bg-gray-100
                        ${isSelected ? 'tw-bg-primary-lighter' : ''}`
            }>
            <Icon icon={EllipsisVerticalIcon} size="sm" variant="dark" colorScheme="light" />
            <p className="tw-mx-2 tw-my-1">{attributeLabel}</p>
            <div className="tw-ml-auto">
                <Tooltip popupContent={attribute.name} />
            </div>
        </div>
    );
};

const DraggableAttribute = memo(CoreDraggableAttribute);

export { DraggableAttribute };
